import { render, staticRenderFns } from "./DataStatsList.vue?vue&type=template&id=4eec40ba&scoped=true"
import script from "./DataStatsList.vue?vue&type=script&lang=js"
export * from "./DataStatsList.vue?vue&type=script&lang=js"
import style0 from "./DataStatsList.vue?vue&type=style&index=0&id=4eec40ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec40ba",
  null
  
)

export default component.exports